<template>

  <b-overlay :show="loading">
    <b-form @submit.prevent="submitForm">

      <p v-if="newHits">Employee has punch records at: {{ newHits }}</p>

      <b-alert :show="off" variant="info">Employee has off day in this day. You might need to override off day to assign a new shift.</b-alert>
      <b-alert :show="!!holiday" variant="info">Employee has holiday( {{ holiday }} ) in this day. You might need to override off day to assign a new shift.</b-alert>

      <b-form-group label="Select Office Time" class="required-field" label-for="shift-select">
        <b-form-select id="shift-select" name="shift_id" v-model="fdata.shift_id" :options="shiftOptions" v-validate="'required'" :state="validateState('shift_id')" aria-describedby="shift_id-feedback" data-vv-as="Office Time"/>
        <b-form-invalid-feedback id="shift_id-feedback">{{ veeErrors.first('shift_id') }}</b-form-invalid-feedback>
      </b-form-group>

      <b-form-row class="mb-3">
        <b-col cols="6">
          <b-form-group id="start_date-group" label="Period Start Date" label-for="start_date" class="required-field">
            <b-input-group>
              <b-form-input :disabled="edit_date != null" id="start_date" name="start_date" v-model="fdata.start_date" v-validate="'required|date_format:yyyy-MM-dd'" type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                            :state="validateState('start_date')" aria-describedby="start_date-feedback" data-vv-as="Period Start Date"/>
              <b-input-group-append>
                <b-form-datepicker :disabled="edit_date != null" @input="fdata.end_date = fdata.start_date" id="day_one" button-only right locale="en-US" v-model="fdata.start_date"/>
              </b-input-group-append>
              <b-form-invalid-feedback id="start_date-feedback">{{ veeErrors.first('start_date') }}</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group id="end_date-group" label="Period End Date" label-for="end_date" class="required-field">
            <b-input-group>
              <b-form-input :disabled="edit_date != null" id="end_date" name="end_date" v-model="fdata.end_date" v-validate="'required|date_format:yyyy-MM-dd'" type="text" placeholder="YYYY-MM-DD"
                            autocomplete="off" :state="validateState('end_date')" aria-describedby="end_date-feedback" data-vv-as="End Date"/>
              <b-input-group-append>
                <b-form-datepicker :disabled="edit_date != null" id="day_two" button-only right locale="en-US" :min="fdata.start_date" v-model="fdata.end_date"/>
              </b-input-group-append>
              <b-form-invalid-feedback id="end_date-feedback">
                {{ veeErrors.first('end_date') }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-group label-for="override_off_day">
        <b-form-checkbox id="override_off_day" name="override_off_day" v-model="fdata.override_off_day" :value="1" :unchecked-value="0">
          Override Off Day
        </b-form-checkbox>
      </b-form-group>

      <b-form-group v-if="roster == 1" label-for="override_shift">
        <b-form-checkbox id="override_shift" name="override_shift" v-model="fdata.override_shift" :value="1" :unchecked-value="0">
          Override Current Office Time In Date
        </b-form-checkbox>
      </b-form-group>

      <b-form-group label-for="overtime">
        <b-form-checkbox id="overtime" name="overtime" v-model="fdata.overtime" :value="1" :unchecked-value="0">
          Overtime
        </b-form-checkbox>
      </b-form-group>

      <b-button type="submit">Create Assignment</b-button>
      <b-button @click="resetForm" type="button">Reset</b-button>
    </b-form>
  </b-overlay>

</template>

<script>
import moment from "moment/moment";

export default {
  props: {
    edit_date: { type: String, default: null },
    newHits: { type: String, default: null },
    off: { type: Boolean, default: false },
    holiday: { type: String, default: null },
  },
  data() {
    return {
      fdata: {
        shift_id: null,
        override_off_day: 0,
        override_shift: 0,
        overtime: 0,
        start_date: this.edit_date,
        end_date: this.edit_date,
        reason: "",
      },
      loading: false,
      roster: 0,
      shiftOptions: [],
    };
  },
  watch: {
    edit_date(v) {
      this.fdata.start_date = v;
      this.fdata.end_date = v;
    },
  },
  created() {
    this.getShifts();
    this.getCompanyLeaveSettings();
  },
  methods: {
  getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.roster = response.data.roster
        }

      }.bind(this));

    },
    validateState(ref)
    {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetForm(){
      this.fdata = {
        shift_id: null,
        start_date: this.edit_date,
        end_date: this.edit_date,
        reason: "",
      };
    },
    getShifts() {
      this.loading = true
      axios.get('/leave-attendance/shifts', {params: {type :'list'}}).then((response) => {
        this.shiftOptions = response.data.map(el => ({
          text: `${el.name} -- (${moment(el.start_time, 'HH:mm:ss').format('hh:mm A')} - ${moment(el.end_time, 'HH:mm:ss').format('hh:mm A')})`,
          value: el.value,
        }));
      }).catch(error => {
        this.serverError(error)
      }).finally(() => { this.loading = false })
    },

    submitForm() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }
        this.loading = true;

        const formData = new FormData();

        for (const [k, v] of Object.entries(this.fdata)) {
          formData.append(k, v);
        }

        axios.post(this.$api_url + '/leave-attendance/shift-assign/manual', formData).then(response => {
          this.$emit('closeModal',response.data.errors);
          this.loading = false;
          this.resetForm();
        }).catch(e => {
          this.loading = false;
          this.$emit('closeModal');
          this.serverError(e);
        });
      });

    },
  },
};
</script>
